export default __webpack_public_path__ + "ocr-financeac3238.jpg";